import { useEffect, useState } from "react";
import axios from "axios";
import DashboardStatsGrid from "../components/DashboardStatsGrid";
import { Form, Input, message, Typography } from "antd";
import "react-toastify/dist/ReactToastify.css";
import "./Maps.scss";
import LoadingScreen from "../lib/constants/loadingScreen";
import { useParams } from "react-router-dom";

const { Title } = Typography;

const UpdateSymptom = () => {
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const { id } = useParams();
  const [form] = Form.useForm();
  const [imageURL, setImageURL] = useState(null);
  const [actionLoading, setActionLoading] = useState(false);
  const [loading, setLoading] = useState(false);

  const config = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("adminticket"),
    },
  };

  useEffect(() => {
    fetchSymptom();
  }, []);

  const fetchSymptom = () => {
    setLoading(true);
    axios
      .get(`${apiBaseUrl}/symptom/${id}`, config)
      .then((response) => {
        if (response.data.success) {
          const symptom = response.data.data;
          form.setFieldsValue({
            symptomName: symptom.name,
          });
          setImageURL(symptom.image);
        }
      })
      .catch((e) => {
        console.error("Failed to fetch symptom", e);
        message.error(
          "Failed to fetch symptom details. Please try again later"
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handlePictureChange = (e) => {
    const file = e.target.files[0];
    form.setFieldsValue({ photo: file });
    setImageURL(URL.createObjectURL(file));
  };

  const addSymptom = async (values) => {
    setActionLoading(true);
    console.log(values);
    const data = new FormData();
    data.append("name", values.symptomName);
    data.append("image", values.photo);
    try {
      const response = await axios.put(
        `${apiBaseUrl}/update-symptom/${id}`,
        data,
        config
      );
      if (response.data.success) {
        message.success("Symptom updated.", 0.6, function onClose() {
          window.location.replace("/dashboard/symptoms");
        });
      } else {
        const errorMessage =
          response.data?.error || "Failed to update symptom! Please try again.";
        message.error(errorMessage);
      }
    } catch (error) {
      console.error("Failed to update symptom:", error);
      const errorMessage =
        error.response?.data?.error ||
        "Internal Server Error! Please try again.";
      message.error(errorMessage);
    } finally {
      setActionLoading(false);
    }
  };

  return (
    <>
      {actionLoading && <LoadingScreen />}

      <DashboardStatsGrid />
      <Form
        form={form}
        onFinish={addSymptom}
        layout="vertical"
        className="forbox w-full max-w-2xl h-fit max-h-lg m-auto py-10 mt-10 px-10 border rounded-lg"
      >
        <Title level={2}>Add Symptom</Title>
        <Form.Item
          label="Symptom Name"
          name="symptomName"
          rules={[{ required: true, message: "Please enter symptom." }]}
        >
          <Input placeholder="Enter symptom" className="py-2" />
        </Form.Item>

        <Form.Item
          label="Image"
          name="photo"
          rules={[{ required: false, message: "Please upload an image" }]}
        >
          <input
            onChange={handlePictureChange}
            type="file"
            className="border border-gray-300 border py-2 px-4 w-full rounded-lg text-gray-700"
          />
          {imageURL && (
            <div>
              <img
                src={imageURL}
                alt="Department Preview"
                className="mt-4 rounded-lg max-h-40"
              />
            </div>
          )}
        </Form.Item>

        <button
          className="mt-4 w-full bg-blue-600 hover:bg-blue-700 text-white border shadow py-3 px-6 font-semibold text-md rounded"
          type="submit"
        >
          Submit
        </button>
      </Form>
    </>
  );
};
export default UpdateSymptom;
